import React from 'react';
import SummaryRow from '../../components/Agreement/SummaryRow';

const Summary = props => {
  const { payments } = props;
  const { Totalamount, Payment, TotalPaid, Depositpayment = 0 } = payments;

  return (
    <div className={'summary'}>
      <div className={'remarks'}>
        <span>备注：</span>**如付现金，必须即时取回电脑收据，并保留至治疗完结，否则无效。<br />
        查询电话：400 888 3182
      </div>
      <div className={'price'}>
        <SummaryRow label={'合约银码：'} labelClassName={'label'}>{Totalamount}</SummaryRow>
        <hr className={'separator'} />
        <SummaryRow label={'付款方法：'}></SummaryRow>
        {Payment.map(({ PaymentMethod, PaidAmount }, i) => (
          <SummaryRow key={i} label={PaymentMethod} labelClassName={'bold'}>{PaidAmount}</SummaryRow>
        ))}
        {Totalamount > TotalPaid + Depositpayment &&
          <SummaryRow label={'尚欠'} rowClassName={'bold red'}>{Totalamount - TotalPaid - Depositpayment}</SummaryRow>
        }
      </div>
    </div>
  );
};

export default Summary;